module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.pageTitle,
      "back-route": "event.index"
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "minicursos",
      "label": "Listagem de Minicursos"
    }
  }, [_c('div', {
    staticClass: "responsive-table"
  }, [(_vm.activeTab === 'minicursos') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Minicurso")]), _vm._v(" "), _c('th', [_vm._v("Minicurso")]), _vm._v(" "), _c('th', [_vm._v("Data do Evento")]), _vm._v(" "), _c('th', [_vm._v("Total Inscritos/Vagas")]), _vm._v(" "), _c('th', {
    staticClass: "btn-actions"
  }, [_vm._v("Lista de Inscritos")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.start_datetime)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v("\n                            " + _vm._s(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0) + "/" + _vm._s(item.vacancies) + "\n                            "), _c('br'), _vm._v(" "), _c('el-progress', {
      attrs: {
        "percentage": _vm.calculaPercentualInscritos(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0, item.vacancies),
        "color": _vm.calculaCor(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0, item.vacancies),
        "text-inside": true,
        "stroke-width": 18
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "el-button el-button--small",
      attrs: {
        "href": item.minicurso_pdf_path,
        "target": "_blank",
        "title": "Lista de Inscritos"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    })])])])
  }))]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fa3661c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/reports/ReportsMinicursos.vue
// module id = 719
// module chunks = 2